<mat-toolbar class="hdr-toolbar">
  <div class="hdr-right">
    <button class="hdr-icon-btn" (click)="openSideNav('callCare')" matTooltip="Open Dialer">
      <div class="hdr-icon-circle blue">
        <mat-icon>phone</mat-icon>
      </div>
      <span class="hdr-icon-label">Dialer</span>
    </button>

    <div class="hdr-divider"></div>

    <button class="hdr-profile-btn" (click)="logOut()" matTooltip="Log Out">
      <div class="hdr-avatar">
        <mat-icon>person</mat-icon>
      </div>
      <div class="hdr-profile-info">
        <span class="hdr-profile-name">Client Agent</span>
        <span class="hdr-profile-role">Log Out</span>
      </div>
      <mat-icon class="hdr-logout-icon">logout</mat-icon>
    </button>
  </div>
</mat-toolbar>
